var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDeliveryHighlightsSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.75C21.59 9.75 21.25 9.41 21.25 9V7C21.25 4.42 19.58 2.75 17 2.75H7C4.42 2.75 2.75 4.42 2.75 7V9C2.75 9.41 2.41 9.75 2 9.75C1.59 9.75 1.25 9.41 1.25 9V7C1.25 3.56 3.56 1.25 7 1.25H17C20.44 1.25 22.75 3.56 22.75 7V9C22.75 9.41 22.41 9.75 22 9.75Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.75H7C3.56 22.75 1.25 20.44 1.25 17V15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15V17C2.75 19.58 4.42 21.25 7 21.25H17C19.58 21.25 21.25 19.58 21.25 17V15C21.25 14.59 21.59 14.25 22 14.25C22.41 14.25 22.75 14.59 22.75 15V17C22.75 20.44 20.44 22.75 17 22.75Z",
    fill: "#FFA800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 8.20999L12.64 6.17999C12.24 5.96999 11.77 5.96999 11.37 6.17999L7.60003 8.20999C7.33003 8.35999 7.16003 8.64999 7.16003 8.96999C7.16003 9.29999 7.33003 9.58999 7.60003 9.73999L11.36 11.77C11.56 11.88 11.78 11.93 12 11.93C12.22 11.93 12.44 11.88 12.64 11.77L16.4 9.73999C16.67 9.58999 16.84 9.29999 16.84 8.96999C16.84 8.64999 16.67 8.35999 16.4 8.20999Z",
    fill: "#FFA800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.74 12.47L7.24 10.72C6.97 10.59 6.66 10.6 6.4 10.76C6.15 10.92 6 11.19 6 11.49V14.8C6 15.37 6.32 15.89 6.83 16.14L10.33 17.89C10.45 17.95 10.58 17.98 10.72 17.98C10.88 17.98 11.03 17.94 11.17 17.85C11.43 17.69 11.58 17.42 11.58 17.12V13.81C11.57 13.24 11.26 12.73 10.74 12.47Z",
    fill: "#FFA800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.59 10.76C17.33 10.6 17.02 10.59 16.75 10.72L13.25 12.47C12.74 12.73 12.42 13.24 12.42 13.81V17.12C12.42 17.42 12.57 17.69 12.83 17.85C12.97 17.94 13.12 17.98 13.28 17.98C13.41 17.98 13.54 17.95 13.67 17.89L17.17 16.14C17.68 15.88 18 15.37 18 14.8V11.49C18 11.19 17.85 10.92 17.59 10.76Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDeliveryHighlightsSectionIcon);
export default __webpack_public_path__ + "99fe93dd9d45b2987da028a2137ec8a9.svg";
export { ForwardRef as ReactComponent };